import { useMemo } from 'react';
import { useAppSelector } from './useAppSelector';

export function usePermissions() {
  const user = useAppSelector((s) => s.auth.user);

  return useMemo(() => {
    const permissions = user?.permissions ?? [];
    const isMaster = user?.masterAdmin === true;
    const has = (code: string) => isMaster || permissions.includes('MASTER_ADMIN') || permissions.includes(code);
    const hasAny = (...codes: string[]) => codes.some(has);
    const hasAll = (...codes: string[]) => codes.every(has);
    const isCashierOnly =
      !isMaster &&
      has('BILLING_CREATE') &&
      !has('ORG_MANAGE') &&
      !has('PRODUCT_MANAGE') &&
      !has('INVENTORY_MANAGE');
    return { permissions, isMaster, has, hasAny, hasAll, isCashierOnly };
  }, [user]);
}
